var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pi-state-legend"},[_c('span',{staticClass:"pi-state-legend__text"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('pi-definition-tooltip',{attrs:{"info-key":_vm.infoKey,"label":_vm.label}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00e0d9c8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/pi/piStateLegend.vue
// module id = 1663
// module chunks = 0